<div #dndPanel class="demo-dnd-panel" role="list" aria-label="Node types to drag onto the model"></div>
